/** Sub-5s close — the anomaly class the desk is hunting. */
export const INSTANT_CLOSE_MS = 5_000;

export function holdMs(
  openedAt?: string | Date | null,
  closedAt?: string | Date | null,
): number | null {
  const open = openedAt instanceof Date ? openedAt.getTime() : Date.parse(String(openedAt ?? ""));
  const close = closedAt instanceof Date ? closedAt.getTime() : Date.parse(String(closedAt ?? ""));
  if (!Number.isFinite(open) || !Number.isFinite(close)) return null;
  return Math.max(0, close - open);
}

export function isInstantClose(
  openedAt?: string | Date | null,
  closedAt?: string | Date | null,
  hold?: number | null,
): boolean {
  const ms = hold ?? holdMs(openedAt, closedAt);
  return ms != null && ms < INSTANT_CLOSE_MS;
}
